import { config } from 'lib-shared-backend-config';
export function resolveUrlByEnvironment(urls) {
    switch (config.backendDomain) {
        case 'euw1.stag.dixa.io':
            return urls.staging1;
        case 'euw1.stag2.dixa.io':
            return urls.staging2;
        case 'euw1.stag3.dixa.io':
            return urls.staging3;
        default:
            return urls.production;
    }
}
// TODO: https://dixa-product.atlassian.net/browse/TEAMS-14956 does the existence of / guarantee that it's an absolute URL?
export function resolveLogoUrl(logo) {
    if (!logo)
        return null;
    // Absolute URLs
    if (logo.includes('/'))
        return logo;
    // File IDs
    return resolveUrlByEnvironment({
        production: `https://files.messenger.dixa.io/${logo}`,
        staging1: `https://files.messenger.stag.dixa.io/${logo}`,
        staging2: `https://files.messenger.stag2.dixa.io/${logo}`,
        staging3: `https://files.messenger.stag3.dixa.io/${logo}`,
    });
}
